export enum AllocationViewProfilesEndpoint {
  DockAndYard = '/dy',
  Monitoring = '/monitoring',
  Profile = '/profile',
  Profiles = '/profiles',
  Default = '/default',
  Filters = '/filters',
  DriverView = '/driver-view',
}
